import { render, staticRenderFns } from "./DepatmentStat.vue?vue&type=template&id=e820728a&scoped=true"
import script from "./DepatmentStat.vue?vue&type=script&lang=js"
export * from "./DepatmentStat.vue?vue&type=script&lang=js"
import style0 from "./DepatmentStat.vue?vue&type=style&index=0&id=e820728a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e820728a",
  null
  
)

export default component.exports